import { IPatient } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { IBaseCommand, IBridgeIntegration } from '../../send-command-to-device';

export const DTX_STUDIO_INTEGRATION: IBridgeIntegration = {
  label: 'DTX Studio',
  description:
    'Two-way integration for taking and uploading radiographic images using Dexis DTX Studio',
};

export type DtxStudioIntegrationCommand = IBaseCommand<
  DtxStudioToDeviceCommand,
  { patient: WithRef<IPatient> }
>;

export enum DtxStudioToDeviceCommand {
  TriggerImageCapture = 'dtxStudio.triggerImageCapture',
  OpenPatient = 'dtxStudio.openPatient',
}

export const DTX_STUDIO_COMMANDS = [
  {
    command: DtxStudioToDeviceCommand.TriggerImageCapture,
    label: 'Acquire Image',
  },
  {
    command: DtxStudioToDeviceCommand.OpenPatient,
    label: 'Open Patient',
  },
];
